import { PulledSemenType } from './types';

export const RS_SEMEN_TYPES = ['RS F', 'RS M'];

export function isMissingRsMoflo(
  semen: Pick<PulledSemenType, 'semenTypeName' | 'moflo'>,
): boolean {
  return (
    RS_SEMEN_TYPES.includes(semen.semenTypeName) &&
    (semen.moflo === null || semen.moflo === undefined || semen.moflo === '')
  );
}

export function getSemenMissingRsMoflo(
  semenRows: PulledSemenType[] | undefined,
): PulledSemenType[] {
  return (semenRows ?? []).filter(isMissingRsMoflo);
}
